import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersMembersApi,
  partnersMembersApiKeys,
  type PartnerMemberInviteRequest,
} from '@/api/routes/partners/partners.members.api';

/** Invite by e-mail. The invite modal owns the error UX (field errors and the inline alert). */
export const usePartnersInviteMember = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PartnerMemberInviteRequest) =>
      partnersMembersApi.invite(data).then((res) => res.data),
    meta: { showUserMessage: false },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: partnersMembersApiKeys.all }),
  });
};
